import { getAffiliateCookieData } from './affiliateCookie';

const TRIVAGO_AFFILIATE_IDS: string[] = [
  '70059',
  'TrivagoFR',
  '70065',
  '70019',
  '70020',
  'TrivagoES',
  '70013',
  '70057',
  '70058',
  '70004',
  '70021',
  '70003',
  '70056',
  'TrivagoPT',
  '70067',
];

export function isTrivagoAffiliateInUrlOrCookie(): boolean {
  const urlParams = new URL(window.location.href).searchParams;
  const affiliateId =
    urlParams.get('affiliate-id') ??
    getAffiliateCookieData()?.affiliateCookieParams.AffiliateId;
  return affiliateId ? TRIVAGO_AFFILIATE_IDS.includes(affiliateId) : false;
}

export function isTrivagoAffiliateInURL(): boolean {
  const urlParams = new URL(window.location.href).searchParams;
  const affiliateId = urlParams.get('affiliate-id');
  return affiliateId ? TRIVAGO_AFFILIATE_IDS.includes(affiliateId) : false;
}
